import React, {useEffect , useState} from 'react'
import {Link , useLocation} from "react-router-dom"
import "./Header.css"
// use location is a function that returns location object
// A <Link> is an element that lets the user navigate to another page by clicking or tapping on it. In react-router-dom, a <Link> renders an accessible
const Header = ()=>{
  const [activeTab,setActiveTab] = useState("Home");
  const location = useLocation();
  useEffect(()=>{
    if(location.pathname==="/"){
      setActiveTab("Home")
    }
    else if(location.pathname==="/add"){
      setActiveTab("AddUser")
    }
    else if(location.pathname==="/about"){
      setActiveTab("About")
    }
  },[location])

  return (
    <div className="header">
        <p className = "logo"> User Management System</p>
        <div className="header-right">
          <Link to = "/">
            <p className={`${activeTab==="Home"?"active":""}`} onClick={()=>setActiveTab("Home")}>Home</p>
          </Link>
          <Link to = "/add">
            <p className={`${activeTab==="AddUser"?"active":""}`} onClick={()=>setActiveTab("AddUser")}>Add User</p>
          </Link>
          <Link to = "/about">
            <p className={`${activeTab==="About"?"active":""}`} onClick={()=>setActiveTab("About")}>About</p>
          </Link>
        </div>

    </div>
  )
}

export default Header
